<template>
    <div>
        <input type="text" ref="pikaday" placeholder="__ . __ . ____" readonly :disabled="disabled"><icon name="close" class="pikaday-clear" @click.native="clearPicker()" v-if="date"></icon>
    </div>
</template>

<script>
import Pikaday from 'pikaday';

export default
{
    name: 'Pikaday',

    props:
    {
        date:
        {
            default: null,
        },

        format:
        {
            type: String,
            default: 'll',
        },

        minDate:
        {
            default: null,
        },

        maxDate:
        {
            default: null,
        },

        setDefaultDate:
        {
            default: true,
        },

        firstDay:
        {
            default: 1,
        },

        showWeekNumber:
        {
            default: true,
        },

        disabled: {
            default: false,
        }
    },

    data()
    {
        return {
            pikaday: null,
            lang:
            {
                de: {
                    previousMonth : 'voriger Monat',
                    nextMonth     : 'nächster Monat',
                    months        : ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
                    weekdays      : ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
                    weekdaysShort : ['So','Mo','Di','Mi','Do','Fr','Sa']
                },

                nl: {
                    previousMonth : 'vorige maand',
                    nextMonth     : 'volgende maand',
                    months        : ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'],
                    weekdays      : ['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'],
                    weekdaysShort : ['zo','ma','di','wo','do','vr','za']
                },

                en: {
                    previousMonth : 'previous month',
                    nextMonth     : 'next month',
                    months        : ['january','february','march','april','may','june','july','august','september','october','november','december'],
                    weekdays      : ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'],
                    weekdaysShort : ['su','mo','tu','we','th','fr','sa']
                },
            }
        }
    },

    mounted()
    {
        let vm = this;
        let id = this.$attrs.id;

        this.pikaday = new Pikaday({
            i18n: this.lang[this.$store.state.meta.lang],
            field: this.$refs.pikaday,
            format: this.format,
            setDefaultDate: this.setDefaultDate,
            defaultDate: this.date ? moment(this.date).toDate() : null,
            //maxDate: this.maxDate,
            maxDate: moment(this.maxDate).toDate(),
            //minDate: this.minDate,
            minDate: moment(this.minDate).toDate(),
            firstDay: this.firstDay,
            showWeekNumber: this.showWeekNumber,
            yearRange: [1950,2050],
            onSelect(val)
            {
                if (val instanceof Date)
                {
                    val = moment(val).format('YYYY-MM-DD');
                }

                vm.$emit('change', val, id);
            },
        });
    },

    watch:
    {
        date(val)
        {
            this.pikaday.setMinDate(null);
            this.pikaday.setMaxDate(null);
            let date = (val == null) ? null : moment(val).toDate();
            this.pikaday.setDate(date, true);
        },

        minDate(val)
        {
            let date = (val == null) ? null : moment(val).toDate();
            this.pikaday.setMinDate(date);
        },

        maxDate(val)
        {
            let date = (val == null) ? null : moment(val).toDate();
            this.pikaday.setMaxDate(moment(date).toDate());
        },
    },

    methods:
    {
        clearPicker()
        {
            this.pikaday.setDate(null, true);
            this.$emit('change', null, this.$attrs.id);
        }, 
    }
}
</script>



// WEBPACK FOOTER //
// Pikaday.vue?53854bb0